import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';
import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-article-card-list', (fragEl, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
